import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import I18NextVue from 'i18next-vue'
import { initI18n } from 'www/utils'
import DoctorContacts from 'www/vue_components/common/DoctorContacts/DoctorContacts.vue'

const mountElement = document.querySelector('.vue-mount-doctor-contacts')

const mountDoctorContacts = async () => {
  if (mountElement) {
    const { i18next } = await initI18n({ bundle: 'vue_components/common/DoctorContacts' })

    Vue.use(I18NextVue, { i18next })

    new Vue({
      el: mountElement,
      vuetify,
      render: h => h(DoctorContacts),
    })
  }
}

mountDoctorContacts()
